export const APIS = {
  WEATHER: "https://api.open-meteo.com/v1/forecast?latitude=32.7157&longitude=117.1611&daily=temperature_2m_max,temperature_2m_min,precipitation_probability_max&timezone=America%2FLos_Angeles",
  AIR_QUALITY: "https://api.waqi.info/feed/san-diego/?token=demo",
};

export const ArcGISMaps = {
  MAIN_MAP: {
    itemId: "572a488a0f9a454bb7f187e65788f12c",
    portalUrl: "https://sdsugeo.maps.arcgis.com/",
    theme: "light"
  },
  SECONDARY_MAP: {
    itemId: "f32704c69daf466ab4abdfb1aec15ad5",
    portalUrl: "https://sdsugeo.maps.arcgis.com/",
    theme: "light"
  }
};

export const dataSources = {
  description: `This dashboard combines data from official government sources, weather APIs, and research organizations to provide a comprehensive analysis of homelessness in San Diego County. Data includes Point-in-Time counts, employment statistics, housing metrics, and real-time environmental conditions.`,
  sources: [
    {
      name: "Regional Task Force on Homelessness",
      type: "Homeless Population Data",
      dataType: "Point-in-Time (PIT) Counts",
      frequency: "Annual",
      url: "https://www.rtfhsd.org/wp-content/uploads/2024/09/2024-San-Diego-Regional-Breakdown.pdf",
      description: "San Diego CoC Region 2024 Point-in-Time Count Data with regional breakdowns"
    },
    {
      name: "Zumper Research",
      type: "Housing Data",
      dataType: "Rental Market Analysis",
      frequency: "Monthly",
      url: "https://www.zumper.com/rent-research/san-diego-ca",
      description: "Current rental market trends and pricing analysis for San Diego"
    },
    {
      name: "U.S. Bureau of Labor Statistics",
      type: "Economic Indicators",
      dataType: "Employment Statistics",
      frequency: "Monthly",
      url: "https://www.bls.gov/regions/west/ca_sandiego_msa.htm",
      description: "Current employment statistics and unemployment rates for San Diego Metropolitan Area"
    },
    {
      name: "HUD Exchange",
      type: "Homeless Population Data",
      dataType: "Point-in-Time (PIT) Counts",
      frequency: "Annual",
      url: "https://www.hudexchange.info/programs/coc/coc-homeless-populations-and-subpopulations-reports/",
      description: "Continuum of Care Homeless Populations and Subpopulations Reports"
    },
    {
      name: "Department of Numbers",
      type: "Housing Data",
      dataType: "Residential Rent Statistics",
      frequency: "Annual",
      url: "https://www.deptofnumbers.com/rent/california/san-diego/",
      description: "San Diego residential rent trends and statistics"
    },
    {
      name: "California Open Data Portal",
      type: "Housing Data",
      dataType: "Housing Element Progress Reports",
      frequency: "Annual",
      url: "https://data.ca.gov/dataset/housing-element-annual-progress-report-apr-data-by-jurisdiction-and-year",
      description: "Housing Element Annual Progress Report (APR) data"
    },
    {
      name: "Open-Meteo API",
      type: "Environmental Data",
      dataType: "Weather Conditions",
      frequency: "Real-time",
      url: "https://open-meteo.com/",
      description: "Current weather conditions and forecasts"
    },
    {
      name: "City of San Diego Open Data Portal",
      type: "Incidents Data",
      dataType: "Eviction Notices",
      frequency: "Daily",
      url: "https://data.sandiego.gov/",
      description: "User reported and police reported incidents"
    }
  ]
};

export const projectInfo = {
  overview: `This project seeks to provide meaningful analysis for understanding the issue of homelessness 
    in San Diego County. It examines how homelessness may be correlated with different economic 
    factors as well as crime rates. Through the use of geo-spatial visualization, forecasting methods, 
    and APIs, this project intends to discover at-risk populations and potential trends.`,
  methodology: `Our methodology combines R, Python, and ArcGIS for advanced geospatial analysis and 
    predictive modeling, integrating Point-in-Time counts, economic indicators, and environmental data. 
    Through clustering techniques and time series forecasting, we can identify patterns and predict future trends, 
    while combining real-time and historical data to provide comprehensive insights for data-driven decision 
    making by policymakers and social service providers.`
};